export const GENDER_UNSET = 0
export const GENDER_MALE = 1
export const GENDER_FEMALE = 2

export function normalizeGenderValue(value, fallback = GENDER_UNSET) {
  if (value === '' || value == null) return fallback

  if (typeof value === 'number') {
    return [GENDER_UNSET, GENDER_MALE, GENDER_FEMALE].includes(value) ? value : fallback
  }

  const text = String(value).trim()
  if (!text) return fallback

  if (text === '0' || text === '未设置' || text === '未知') return GENDER_UNSET
  if (text === '1' || text === '男' || /^male$/i.test(text)) return GENDER_MALE
  if (text === '2' || text === '女' || /^female$/i.test(text)) return GENDER_FEMALE

  return fallback
}

export function getGenderLabel(value) {
  const normalized = normalizeGenderValue(value)
  if (normalized === GENDER_MALE) return '男'
  if (normalized === GENDER_FEMALE) return '女'
  return '未设置'
}

export function getGenderTone(value) {
  const normalized = normalizeGenderValue(value)
  if (normalized === GENDER_MALE) return 'info'
  if (normalized === GENDER_FEMALE) return 'success'
  return 'neutral'
}

export function buildGenderOptions({
  includePlaceholder = false,
  placeholderLabel = '请选择性别'
} = {}) {
  const options = [
    { label: '未设置', value: GENDER_UNSET },
    { label: '男', value: GENDER_MALE },
    { label: '女', value: GENDER_FEMALE }
  ]

  if (!includePlaceholder) return options
  return [{ label: placeholderLabel, value: '' }, ...options]
}
